import { Box, Flex, HStack, Spinner, Text } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { Map } from "components/Organismos/Map";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "store/hooks";
import { getManifestacoesGeojsonRequest } from "store/modules/ouvidoria/manifestacoes/actions/getManifestacoesGeojson";
import { EssencialGeojson } from "./components/EssencialGeojson";
import { InformativoGeojson } from "./components/InformativoGeojson";
import { ManifestacaoGeojson } from "./components/ManifestacaoGeojson";
import { ControlPortal } from "components/Organismos/Map/Controls/base/ControlPortal";
import { MarkerChooseHandler } from "./components/MarkerChooseHandler";
import { SideNovaManifestacao } from "./components/SideNovaManifestacao";
import CriarManifestacaoContextProvider from "./contexts/CriarManifestacaoProvider";
import { CriarManifestacaoButton } from "./components/CriarManifestacaoButton";
import { PopupMap } from "components/Organismos/Map/PopupNotification/PopupMap";
import VerManifestacaoProvider from "./contexts/VerManifestacaoProvider";
import { SideVerManifestacao } from "./components/SideVerManifestacao";
import { SideMapLista } from "./components/SideMapLista";
import VerListagemProvider from "./contexts/VerListagemProvider";
import { ToggleVerListagemButton } from "./components/ToggleVerListagemButton";
import { SimpleLegendColorMapa } from "components/Organismos/Map/Controls/SimpleLegendColorMapa";

export const OuvidoriaHome = () => {
  const dispatch = useDispatch();

  const { isRequesting: loadingInformatives, successPayload: informatives } =
    useTypedSelector(
      (state) => state.ouvidoria.informativo.getInformativesGeojson
    );

  const {
    isRequesting: loadingEssentialServices,
    successPayload: essentialServices
  } = useTypedSelector(
    (state) => state.ouvidoria.pontosessenciais.getEssentialServicesGeojson
  );

  const { isRequesting: loadingComplaints, successPayload: complaints } =
    useTypedSelector(
      (state) => state.ouvidoria.manifestacoes.getManifestacoesGeojson
    );

  return (
    <CriarManifestacaoContextProvider>
      <VerManifestacaoProvider>
        <VerListagemProvider>
          <Box h="100%" position="relative">
            <Map>
              <Outlet />
              {essentialServices && (
                <EssencialGeojson featureCollection={essentialServices} />
              )}
              {informatives && (
                <InformativoGeojson featureCollection={informatives} />
              )}
              {complaints && (
                <ManifestacaoGeojson featureCollection={complaints} />
              )}

              <ControlPortal position="bottomrightSecondary" appendType="after">
                <SimpleLegendColorMapa
                  legenda={[
                    { color: "#CC862C", title: "Ponto essencial" },
                    { color: "#3ABC30", title: "Ponto Informativo" },
                    { color: "#CC2F44", title: "Manifestação" }
                  ]}
                />
              </ControlPortal>

              <ControlPortal position="topleft">
                <HStack>
                  <ToggleVerListagemButton />
                  <CriarManifestacaoButton />
                </HStack>
                <SideMapLista />
              </ControlPortal>

              <MarkerChooseHandler />

              <SideNovaManifestacao
                onSuccess={() => {
                  dispatch(getManifestacoesGeojsonRequest());
                }}
              />
              <SideVerManifestacao />
            </Map>
            {(loadingInformatives ||
              loadingEssentialServices ||
              loadingComplaints) && (
              <PopupMap>
                <Flex align="center">
                  <Text fontSize="lg">Buscando geometrias</Text>
                  <Spinner size="sm" ml="2" color="gray.500" />
                </Flex>
              </PopupMap>
            )}
          </Box>
        </VerListagemProvider>
      </VerManifestacaoProvider>
    </CriarManifestacaoContextProvider>
  );
};
